@if (showOnHoldPopup) {
  <div class="checkIn tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end tw-justify-center">
    <div class="tw-absolute tw-w-full tw-bg-[#0B0B0B] tw-opacity-70 tw-h-full tw-max-h-unset tw-max-w-full tw-rounded-0 tw-p-0 tw-inset-0"></div>
    <div class="tw-absolute tw-pl-1 tw-pr-1 tw-bottom-[88px] tw-w-full tw-z-10">
      <div class="tw-relative tw-rounded-3 tw-bg-gray-100 tw-rounded-t-2xl tw-shadow-xl tw-pb-[28px]">
        <div class="tw-flex tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-bg-white tw-border-r tw-justify-between tw-pt-4 tw-pr-4 tw-pl-4 tw-items-center tw-pb-2">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <img src="/assets/icons/sparkles-sharp.svg" class="tw-w-4"/>
            <span class="tw-text-200 tw-text-gray-900 tw-font-body" i18n="@@csHealthAssistant">Cure Health Assistant</span>
          </div>
          <img src="/assets/icons/gray-cross.svg"class="tw-cursor-pointer" (click)="onHoldResponseCancel()"/>
        </div>
        <div class="tw-flex tw-bg-gray-100 tw-flex-col tw-items-center tw-text-center tw-pt-4 tw-pr-4 tw-pl-4">
          <div class="tw-flex tw-items-center tw-justify-center tw-w-[54px]">
            <img src="/assets/gifs/ai-star-blur.gif" class="tw-w-[54px]"/>
          </div>
          <h2 class="tw-text-500 tw-text-gray-900 tw-font-body tw-font-bold tw-mt-1 tw-mb-6" i18n="@@quickCheckin">Quick check-in 👋</h2>
          <p class="tw-bg-white tw-border-gray-200 tw-border-solid tw-border-[1px] tw-rounded-[12px] tw-pt-[18px] tw-pb-[18px] tw-pl-[21px] tw-pr-[21px] tw-text-300 tw-text-gray-800 tw-mb-3" i18n="@@improvementFeedback">
          It's been {{onHoldData?.onHoldDurationInDays}} days since you mentioned the discomfort. Has there been any improvement?
        </p>
          <div class="tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-4">
            <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center" (click)="onHoldResponseYes()" i18n="@@yes">Yes</p>
            <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center" (click)="onHoldResponseNo()" i18n="@@no">No</p>
          </div>
        </div>
        <div class="tw-absolute tw-bg-gray-100 tw-w-[72px] tw-bottom-[-80px] tw-h-[80px] tw-left-[29%] bottom-extension tw--translate-x-1/2 !tw-rounded-t-none !tw-rounded-b-lg">
          <div class="tw-absolute tw-left-5 tw-top-5 tw-flex tw-items-center tw-flex-col">
            <img src="/assets/icons/help-teal.svg" alt="" class="tw-w-8 tw-h-8"/>
            <span class="tw-font-body tw-text-teal-500 tw-text-200" i18n="@@help">Help</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showFeelingBetterPopup) {
  <div class="feelingBetter tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end tw-justify-center">
    <div class="tw-absolute tw-w-full tw-bg-[#0B0B0B] tw-opacity-70 tw-h-full tw-max-h-unset tw-max-w-full tw-rounded-0 tw-p-0 tw-inset-0"></div>
    <div class="tw-absolute tw-pl-1 tw-pr-1 tw-bottom-[88px] tw-w-full tw-z-10">
      <div class="tw-relative tw-rounded-3 tw-bg-gray-100 tw-rounded-t-2xl tw-shadow-xl tw-pb-[28px]">
        <div class="tw-flex tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-bg-white tw-border-r tw-justify-between tw-pt-4 tw-pr-4 tw-pl-4 tw-items-center tw-pb-2">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <img src="/assets/icons/sparkles-sharp.svg" class="tw-w-4"/>
            <span class="tw-text-200 tw-text-gray-900 tw-font-body" i18n="@@csHealthAssistant">Cure Health Assistant</span>
          </div>
          <img src="/assets/icons/gray-cross.svg" class="tw-cursor-pointer" (click)="showFeelingBetterPopup = !showFeelingBetterPopup"/>
        </div>
        <div class="tw-flex tw-bg-gray-100 tw-flex-col tw-items-center tw-text-center tw-pt-4 tw-pr-4 tw-pl-4">
          <div class="tw-flex tw-items-center tw-justify-center tw-w-[54px]">
            <img src="/assets/gifs/ai-star-blur.gif" class="tw-w-[54px]"/>
          </div>
          <h2 class="tw-text-500 tw-text-gray-900 tw-font-body tw-font-bold tw-mt-1 tw-mb-6" i18n="@@gladToHear">Glad to hear that you're feeling better! 😊</h2>
          <p class="tw-bg-white tw-border-gray-200 tw-border-solid tw-border-[1px] tw-rounded-[12px] tw-pt-[18px] tw-pb-[18px] tw-pl-[21px] tw-pr-[21px] tw-text-300 tw-text-gray-800 tw-mb-3" i18n="@@feelingBetterInfo">
          If anything else bothers you or comes back, don't hesitate to reach out - we're here to help.
        </p>
          <div class="tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-4">
            <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center" (click)="viewInstruction()" i18n="@@viewInstruction">View Instructions</p>
          </div>
        </div>
        <div class="tw-absolute tw-bg-gray-100 tw-w-[72px] tw-bottom-[-80px] tw-h-[80px] tw-left-[29%] bottom-extension tw--translate-x-1/2 !tw-rounded-t-none !tw-rounded-b-lg">
          <div class="tw-absolute tw-left-5 tw-top-5 tw-flex tw-items-center tw-flex-col">
            <img src="/assets/icons/help-teal.svg" alt="" class="tw-w-8 tw-h-8"/>
            <span class="tw-font-body tw-text-teal-500 tw-text-200" i18n="@@help">Help</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showNotFeelingBetterPopup) {
  <div class="notFeelingBetter tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-end tw-justify-center">
    <div class="tw-absolute tw-w-full tw-bg-[#0B0B0B] tw-opacity-70 tw-h-full tw-max-h-unset tw-max-w-full tw-rounded-0 tw-p-0 tw-inset-0"></div>
    <div class="tw-absolute tw-pl-1 tw-pr-1 tw-bottom-[88px] tw-w-full tw-z-10">
      <div class="tw-relative tw-rounded-3 tw-bg-gray-100 tw-rounded-t-2xl tw-shadow-xl tw-pb-[28px]">
        <div class="tw-flex tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-bg-white tw-border-r tw-justify-between tw-pt-4 tw-pr-4 tw-pl-4 tw-items-center tw-pb-2">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <img src="/assets/icons/sparkles-sharp.svg" class="tw-w-4"/>
            <span class="tw-text-200 tw-text-gray-900 tw-font-body" i18n="@@csHealthAssistant">Cure Health Assistant</span>
          </div>
          <img src="/assets/icons/gray-cross.svg"class="tw-cursor-pointer" (click)="showNotFeelingBetterPopup = !showNotFeelingBetterPopup"/>
        </div>
        <div class="tw-flex tw-bg-gray-100 tw-flex-col tw-items-center tw-text-center tw-pt-4 tw-pr-4 tw-pl-4">
          <div class="tw-flex tw-items-center tw-justify-center tw-w-[54px]">
            <img src="/assets/gifs/ai-star-blur.gif" class="tw-w-[54px]"/>
          </div>
          <h2 class="tw-text-500 tw-text-gray-900 tw-font-body tw-font-bold tw-mt-1 tw-mb-6" i18n="@@sorryToHearOnHold">Sorry to hear that you're still facing {{llmSubCategory}}.</h2>
          @if (onHoldPopupResponse?.data?.redirectToTicket) {
            <p class="tw-bg-white tw-border-gray-200 tw-border-solid tw-border-[1px] tw-rounded-[12px] tw-pt-[18px] tw-pb-[18px] tw-pl-[21px] tw-pr-[21px] tw-text-300 tw-text-gray-800 tw-mb-3" i18n="@@shareMoreDetails">
          Could you share more details about your concern? This will help us assist you better.
        </p>
          }
          @if (!onHoldPopupResponse?.data?.redirectToTicket) {
            <p class="tw-bg-white tw-border-gray-200 tw-border-solid tw-border-[1px] tw-rounded-[12px] tw-pt-[18px] tw-pb-[18px] tw-pl-[21px] tw-pr-[21px] tw-text-300 tw-text-gray-800 tw-mb-3" i18n="@@onHoldExtend">
          Sorry to hear you’re not feeling well. Please continue the prescribed regimen. We'll check in via the app in 7 days.
        </p>
          }
          @if (onHoldPopupResponse?.data?.redirectToTicket) {
            <div class="tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-4">
              <p class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-font-bold tw-relative tw-overflow-hidden tw-text-center" (click)="openTicket()" i18n="@@goToTicket">Open Ticket</p>
            </div>
          }
        </div>
        <div class="tw-absolute tw-bg-gray-100 tw-w-[72px] tw-bottom-[-80px] tw-h-[80px] tw-left-[29%] bottom-extension tw--translate-x-1/2 !tw-rounded-t-none !tw-rounded-b-lg">
          <div class="tw-absolute tw-left-5 tw-top-5 tw-flex tw-items-center tw-flex-col">
            <img src="/assets/icons/help-teal.svg" alt="" class="tw-w-8 tw-h-8"/>
            <span class="tw-font-body tw-text-teal-500 tw-text-200" i18n="@@help">Help</span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
